import { render } from "./DefaultNotification.vue?vue&type=template&id=6c50783c"
import script from "./DefaultNotification.vue?vue&type=script&lang=js"
export * from "./DefaultNotification.vue?vue&type=script&lang=js"
script.render = render

export default script